import { Component, computed, inject, Input, signal, ChangeDetectionStrategy } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { SAMPLE_YEAR } from '../energy-balance-data';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { YearBalanceChartComponent } from './year-balance-chart.component';

import { environment } from '../../../../../environments/environment';
import { EnergyBalanceResponse } from '../../../../../api/models/energy-balance-response';
import { Api } from '../../../../../api/api';
import { getEnergyBalances } from '../../../../../api/functions';
import { LocationStateService } from '../../../../../common/services/location-state.service';
import { from } from 'rxjs';

@Component({
  selector: 'app-yearly-energy-balance',
  templateUrl: './year-balance.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatInputModule, MatFormFieldModule, MatDatepickerModule, YearBalanceChartComponent],
})
export class YearBalanceComponent {
  api = inject(Api);
  startDate = signal(new Date());
  endDate = signal(new Date());
  locationStateService = inject(LocationStateService);

  @Input()
  set date(value: Date) {
    this.startDate.set(new Date(value.getFullYear(), 0, 1));
    this.endDate.set(new Date(value.getFullYear(), 11, 31, 23, 59, 59));
  }

  params = computed(() => ({
    location_id: this.locationStateService.currentLocation()?.id ?? '',
    aggregation: 'year',
    from: this.startDate().toISOString(),
    to: this.endDate().toISOString(),
  }));

  resource = rxResource({
    params: this.params,
    defaultValue: environment.showDefault ? SAMPLE_YEAR : undefined,
    stream: (loaderParams) => from(this.api.invoke(getEnergyBalances, loaderParams.params)),
  });

  data = computed((): EnergyBalanceResponse[] => (this.resource.hasValue() ? this.resource.value() : []));
}
